export const termsAndConditionsConstants = {
  ADD_OR_UPDATE_TERMS_AND_CONDITIONS: "ADD_OR_UPDATE_TERMS_AND_CONDITIONS",
  GET_TERMS_AND_CONDITIONS: "GET_TERMS_AND_CONDITIONS",
};